import { render, staticRenderFns } from "./servicePlan.vue?vue&type=template&id=5d74c320&scoped=true&"
import script from "./servicePlan.vue?vue&type=script&lang=js&"
export * from "./servicePlan.vue?vue&type=script&lang=js&"
import style0 from "./servicePlan.vue?vue&type=style&index=0&id=5d74c320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d74c320",
  null
  
)

export default component.exports